'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

require('isomorphic-fetch');

var _fetchival = require('fetchival');

var _fetchival2 = _interopRequireDefault(_fetchival);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _reactI18next = require('react-i18next');

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _lodash = require('lodash');

var _chemist = require('chemist');

var _ReduxErrorPublisher = require('../shared/helpers/ReduxErrorPublisher');

var _ReduxErrorPublisher2 = _interopRequireDefault(_ReduxErrorPublisher);

var _createApiClient = require('../shared/helpers/createApiClient');

var _createApiClient2 = _interopRequireDefault(_createApiClient);

var _index = require('../config/locales/phraseapp/index.translations');

var _index2 = _interopRequireDefault(_index);

var _store = require('../shared/store');

var _store2 = _interopRequireDefault(_store);

var _routes = require('../shared/routes');

var _routes2 = _interopRequireDefault(_routes);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/imports-first*/
if (global.Raven) global.Raven.config('https://71f97ab57c3b46ca814dc6ff836c269a@sentry.io/134846').install();
if (!global._babelPolyfill) {
  require('babel-polyfill');
}


global.fetchival = _fetchival2.default;
global.adyenEncrypt = require('adyen-cse-js');

function i18nFallback() {
  var dialect = window.__locale.split('-').shift();
  var defaultLng = 'en';

  if (dialect === defaultLng) {
    return defaultLng;
  }

  return (0, _lodash.concat)([], dialect, defaultLng);
}

_i18next2.default.init({ lng: window.__locale, fallbackLng: i18nFallback(), resources: _index2.default });

var apiClient = (0, _createApiClient2.default)({
  host: _config2.default.apiHost,
  port: _config2.default.apiPort
});

var store = (0, _store2.default)(_reactRouter.browserHistory, apiClient, window.__data);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store, { adjustUrlOnReplay: false });
var root = document.getElementById('content');
var renderAsync = function renderAsync(props) {
  return _react2.default.createElement(_reduxConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, {
    helpers: { client: apiClient },
    filter: function filter(item) {
      return !item.deferred;
    }
  }));
};

var router = _react2.default.createElement(
  _reactRouter.Router,
  { history: history, render: renderAsync },
  (0, _routes2.default)(store)
);

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  _react2.default.createElement(
    _reactI18next.I18nextProvider,
    { i18n: _i18next2.default },
    _react2.default.createElement(
      _chemist.AppConfigProvider,
      { config: JSON.parse(window.__appConfig) },
      _react2.default.createElement(
        _ReduxErrorPublisher2.default,
        null,
        router
      )
    )
  )
), root);


//////////////////
// WEBPACK FOOTER
// ./client/index.js
// module id = 2240
// module chunks = 0